var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bottom-sheet-overflow-button',{attrs:{"bottom-sheet-component":_vm.sheetComponent,"menu-items":_vm.menuItems,"component-props":{ menuItems: _vm.menuItems, sheetProps: {disabled: _vm.isLoading} },"menuButtonColor":_vm.menuButtonColor}})}
var staticRenderFns = []

export { render, staticRenderFns }